import { render, staticRenderFns } from "./customerList_gr.vue?vue&type=template&id=29185242&scoped=true&"
import script from "./customerList_gr.vue?vue&type=script&lang=js&"
export * from "./customerList_gr.vue?vue&type=script&lang=js&"
import style0 from "./customerList_gr.vue?vue&type=style&index=0&id=29185242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29185242",
  null
  
)

export default component.exports